import { FC } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../hooks/useRateFieldName";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardIconButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTooltip } from "@/dashboard-design-system/DashboardTooltip";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";
import { Hide, Reveal } from "@/icons/outlined";

interface VisibilityToggleFieldProps {
  hideLabel?: string;
  showLabel?: string;
}

export const VisibilityToggleField: FC<VisibilityToggleFieldProps> = ({ hideLabel, showLabel }) => {
  const { t } = useTranslate();
  const { control, setValue } = useFormContext<StepTicketsFormData>();

  const fieldName = useRateFieldName("isHidden");
  const isHidden = useWatch({ control, name: fieldName });

  return (
    <DashboardTooltip
      title={
        isHidden
          ? (showLabel ?? t("dashboard", "ticketing.shopItem.show"))
          : (hideLabel ?? t("dashboard", "ticketing.shopItem.hide"))
      }
    >
      <DashboardIconButton
        onClick={() => setValue(fieldName, !isHidden, { shouldDirty: true })}
        size="small"
        vibe="neutral"
        data-test="card-visibility-toggle"
      >
        {isHidden ? <Hide /> : <Reveal />}
      </DashboardIconButton>
    </DashboardTooltip>
  );
};
